import React from "react";
import { Checkbox } from "@mui/material";
import UncheckedIcon from "assets/images/svg-icons/checkboxUnchecked.svg";
import CheckedIcon from "assets/images/svg-icons/checkboxChecked.svg";
import MuiBox from "../MuiBox";

const CustomCheckbox = (props) => {
  return (
    <Checkbox
      icon={
        <MuiBox sx={{ height: "16px", width: "16px" }}>
          <img src={UncheckedIcon} alt="unchecked" className="img-full" />
        </MuiBox>
      }
      checkedIcon={
        <MuiBox sx={{ height: "16px", width: "16px" }}>
          <img src={CheckedIcon} alt="checked" className="img-full" />
        </MuiBox>
      }
      {...props}
    />
  );
};

export default CustomCheckbox;
